export enum SortTypeEnum {
  ASC = 'asc',
  DESC = 'desc',
  DEFAULT = '',
}
